module.exports = __webpack_public_path__ + "static/media/rightarrow.c63d7fee.svg";